<template>
    <div>
        <h3 @click="enableDebug($event)" class="display-4">
            Manage Permissions
        </h3>

        <o-list-toolbar
            :filters-list="filter_list"
            :list-options="list_options"
            :new-to="{ name: 'permission.create', params: { id: 0 } }"
            :query-select-options="options"
            :schema="schema"
            :search-fields-list="search_field_list"
            :selected-filter="selected_filter"
            @filter_changed="update_filter($event)"
            @options_changed="update_table($event)"
            @reset_table="reset_table"
            new-button-text="New Permission"
        >
        </o-list-toolbar>

        <b-table
            :fields="fields"
            :items="items"
            :sort-by="list_options.sort"
            :sort-desc="list_options.order == 'desc'"
            @sort-changed="change_sort"
            bordered
            head-variant="light"
            no-local-sorting
            striped
        >
            <template slot="cell(name)" slot-scope="{ index, item }">
                <router-link
                    :to="{ name: 'permission.edit', params: { id: item.id } }"
                >
                    <default-display :value="item.name"></default-display>
                </router-link>
            </template>
            <template slot="cell(content_type)" slot-scope="{ index, item }">
                <lookup-display
                    :list="optionContentTypeItemsById"
                    :value="item.content_type"
                    default-value="-"
                    display-field="app_label"
                ></lookup-display>
            </template>
            <template slot="cell(codename)" slot-scope="{ index, item }">
                <default-display :value="item.codename"></default-display>
            </template>

            <template slot="empty">
                <p>
                    <emoticon-sad-icon large></emoticon-sad-icon>
                </p>
                No Data Found. Please
                <router-link :to="{ name: 'permission.create' }"
                    >create a new item</router-link
                >
            </template>
        </b-table>

        <o-list-paging
            :limit="list_options.limit"
            :offset="list_options.offset"
            :page-options="rows_per_page_items"
            :total-items="total_items"
            @change-limit="change_limit"
            @change-page="change_page"
        />
    </div>
</template>

<style></style>

<script>
import {
    CreateCodeTableFetchMixin,
    CreateListPageMixin,
} from "../../../mixins";
import {
    fieldToTableColumn,
    GetSearchFields,
} from "../../../schema/schema_utils";
import schema from "../../schema/index";

import OListToolbar from "../../../components/list/OListToolbar";
import OListPaging from "../../../components/list/OListPaging";
import DefaultDisplay from "../../../components/display/DefaultDisplay";
import DateDisplay from "../../../components/display/DateDisplay";
import NumberDisplay from "../../../components/display/NumberDisplay";
import BooleanDisplay from "../../../components/display/BooleanDisplay";
import LookupDisplay from "../../../components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
    components: {
        EmoticonSadIcon,
        EmailIcon,
        LinkIcon,
        OListPaging,
        OListToolbar,
        DateDisplay,
        DefaultDisplay,
        BooleanDisplay,
        NumberDisplay,
        LookupDisplay,
    },
    mixins: [
        CreateListPageMixin("Permission", "permission"),
        CreateCodeTableFetchMixin(["ContentType"]),
    ],

    data: function () {
        return {
            schemaModel: schema.Permission,

            search_field_list: GetSearchFields(schema.Permission),

            filter_list: [
                {
                    name: "Active",
                    code: "active",
                    options: { offset: 0, sort: "id" },
                },
                {
                    name: "Non Active",
                    code: "inactive",
                    options: { offset: 0, sort: "id" },
                },
                {
                    name: "All",
                    code: "all",
                    options: { offset: 0, sort: "id" },
                },
            ],
        };
    },
    computed: {
        options() {
            return {
                ContentType: {
                    options: this.optionContentTypeItems,
                    textField: "app_label",
                    valueField: "id",
                },
            };
        },
        fields() {
            return [
                fieldToTableColumn(this.schema, "name"),
                fieldToTableColumn(this.schema, "content_type"),
                fieldToTableColumn(this.schema, "codename"),
            ];
        },
    },
};
</script>
